import { resourcePermissionsOperations } from '@ardoq/access-control';
import { isEqual } from 'lodash';
import { combineLatest, map, distinctUntilChanged, Observable } from 'rxjs';
import { loadedState$ } from 'loadedState/loadedState$';
import { currentUserPermissionContext$ } from 'streams/currentUserPermissions/currentUserPermissionContext$';
import { isSingleTraversalState } from './saveAsViewpoint/saveAsViewpoint$/isSingleTraversalState';

export type CurrentViewpointUserPermissions = {
  canCreateViewpoint: boolean;
  canUpdateViewpoint: boolean;
};

const currentViewpointUserPermissions$: Observable<CurrentViewpointUserPermissions> =
  combineLatest([loadedState$, currentUserPermissionContext$]).pipe(
    map(([{ loadedStates }, permissionContext]) => {
      const traversalId = isSingleTraversalState(loadedStates)
        ? loadedStates[0].traversalId
        : null;

      return {
        canCreateViewpoint:
          resourcePermissionsOperations.canCreateTraversal(permissionContext),
        canUpdateViewpoint: traversalId
          ? resourcePermissionsOperations.canEditTraversal(
              permissionContext,
              traversalId
            )
          : false,
      };
    }),
    distinctUntilChanged((a, b) => isEqual(a, b))
  );

export { currentViewpointUserPermissions$ };
